"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const merge_1 = __importDefault(require("merge"));
function merge(s, ...t) {
    return merge_1.default.recursive(s, ...t);
}
exports.default = merge;
